import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import DetailYoutubeEmbed from './detail-youtube-embed'
import useDetailStyles from '../detail-styles'
import DetailSection from './detail-section'
import DownloadPlanHeaderAction from './download-plan-header-action'
import { downloadActivity } from '../lib/plan-download'
import useRegisterActivityPlanDetailHeader from '../hooks/use-register-activity-plan-detail-header'
import {
  getActivityVideoMediaId,
  getAssessmentVideoMediaId,
} from '../lib/resolve-youtube-media-id'

const ActivityDetailView = ({ hit }) => {
  const classes = useDetailStyles()

  const setupDuration = hit.details?.setupDuration
  const durationMins = hit.details?.durationMins
  const subtitle = [
    setupDuration != null ? `Setup ${setupDuration} min` : null,
    durationMins != null ? `Duration ${durationMins} min` : null,
  ]
    .filter(Boolean)
    .join(' · ')

  const activityVideoId = getActivityVideoMediaId(hit)
  const assessmentTitle = hit.details?.assessmentTitle || 'Assessment'
  const assessmentText = hit.details?.assessmentText
  const assessmentVideoId = getAssessmentVideoMediaId(hit)
  const hasAssessmentContent =
    Boolean(assessmentText) ||
    Boolean(assessmentVideoId) ||
    Boolean(hit.details?.assessmentTitle)

  const { HeaderActionsPortal } = useRegisterActivityPlanDetailHeader({
    title: hit.title,
    subtitle,
  })

  return (
    <>
      <HeaderActionsPortal>
        <DownloadPlanHeaderAction
          buttonLabel="Download Activity"
          dialogTitle="Download activity"
          dialogDescription="Download this activity as a text file. Click Download to save it to your device."
          onDownload={() => downloadActivity(hit)}
        />
      </HeaderActionsPortal>
      <Box className={classes.contentContainer}>
        {activityVideoId ? (
          <DetailSection title="Video">
            <DetailYoutubeEmbed embedId={activityVideoId} />
          </DetailSection>
        ) : null}

        {hit.details?.summary ? (
          <DetailSection title="Summary">
            <Typography component="p" className={classes.bodyText}>
              {hit.details.summary}
            </Typography>
          </DetailSection>
        ) : null}

        {hit.details?.equipment ? (
          <DetailSection title="Equipment">
            <Typography component="p" className={classes.bodyText}>
              {hit.details.equipment}
            </Typography>
          </DetailSection>
        ) : null}

        {hit.details?.setup ? (
          <DetailSection title="Setup">
            <Typography component="p" className={classes.bodyText}>
              {hit.details.setup}
            </Typography>
          </DetailSection>
        ) : null}

        {hit.details?.detail ? (
          <DetailSection title="Instructions">
            <Typography component="p" className={classes.bodyText}>
              {hit.details.detail}
            </Typography>
          </DetailSection>
        ) : null}

        {hasAssessmentContent ? (
          <Box className={classes.section}>
            <Typography component="h2" className={classes.sectionEyebrow}>
              {assessmentTitle}
            </Typography>
            <Box className={classes.sectionCard}>
              {assessmentText ? (
                <Typography component="p" className={classes.bodyText}>
                  {assessmentText}
                </Typography>
              ) : null}
              {assessmentVideoId ? (
                <Box
                  className={assessmentText ? classes.videoWrapper : undefined}
                >
                  <DetailYoutubeEmbed embedId={assessmentVideoId} />
                </Box>
              ) : null}
            </Box>
          </Box>
        ) : null}
      </Box>
    </>
  )
}

ActivityDetailView.propTypes = {
  hit: PropTypes.object.isRequired,
}

export default ActivityDetailView
